import React from 'react';
import Nav from "react-bootstrap/Nav";
import {Link} from "react-router-dom";
import Icon, {IconProps} from "../../common/Icon";
import MenuItem from "./MenuItem";
import brand from '../../images/brand-white.svg';

import './Navigation.scss';

/**
 * Main navigation component.
 */
class Navigation extends React.Component {

  render() {
    // TODO: toggle for expand/collapse
    // TODO: if resized for a small device, this looks awful
    return (
      <Nav className="flex-column Navigation">
        <Link to="/" className={"NavBrand"}>
          <img src={brand} alt="Ontotext Platform Workbench" height="65"/>
        </Link>

        <MenuItem path="/schemas">
          <MenuItemIcon icon={['far', 'list-alt']}/> Schemas
        </MenuItem>

        <MenuItem path="/schema/playground">
          <MenuItemIcon icon={['far', 'file-code']}/> Playground
        </MenuItem>

        <MenuItem path="/graphql">
          <MenuItemIcon icon={['fas', 'project-diagram']}/> GraphQL
        </MenuItem>

        <MenuItem path="/search">
          <MenuItemIcon icon={['fas', 'search']}/> Search
        </MenuItem>

        <MenuItem path="/monitoring">
          <MenuItemIcon icon={['fas', 'tv']} size='2x'/> Monitoring
        </MenuItem>

        <MenuItem path={process.env.REACT_APP_PLATFORM_SITE || ''} external={true}
                  className="DocumentationLink">
          <MenuItemIcon icon={['far', 'question-circle']}/>
          Documentation
          <sup className="pl-1">
            <Icon className="ExternalLinkIcon" icon={['fas', 'external-link-alt']}/>
          </sup>
        </MenuItem>
      </Nav>
    );
  }

}

function MenuItemIcon(props: IconProps) {
  return <Icon {...props} className="MenuItemIcon" size='2x'/>;
}

export default Navigation;
